import { Observable } from "rxjs";

export interface Form {
  name: string;
  settings: any;
  fields?: any;
  notAllowed?: any;
  extraHTML?: string;
  uid: string;
  id: string;
  timestamp?: number;
  leadsToday?: number;
  leadsWeek?: number;
  leadsMonth?: number;
  leadsTotal?: number;
}

export abstract class FormData {
  abstract createForm(form: Form);
  abstract getForms(pagination, filter, order);
  abstract getForm(id: string);
  abstract editForm(data: Form, id: string);
  abstract deleteForm(id: string);
  abstract duplicateForm(id: string);
}
